<template>
  <div class="subscription">
    <transition name="fade" mode="in-out">
      <div
        :key="currentImg"
        class="subscription__bg"
        :style="`background-image: url('${currentImg}')`"
      ></div>
    </transition>
    <div class="subscription__content">
      <div class="subscription__form">
        <img
          src="@/assets/img/upmood_logo.svg"
          alt="upmood-logo"
          class="logo"
        />
        <h2>Subscribe to our newsletter</h2>
        <p>
          Plus the latest news on our new product just by <br />subscribing to
          our newsletter.
        </p>
        <form class="input-wrapper" @submit.prevent="subscribe">
          <input
            type="text"
            placeholder="E-Mail Address"
            required
            v-model="email"
            :disabled="sending"
          />
          <button class="button-cyan" type="submit" :disabled="sending">
            {{ sending ? "..." : "Subscribe" }}
          </button>
        </form>
      </div>
    </div>
    <span class="close" @click="close">&times;</span>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: ["currentImg"],
  data() {
    return {
      email: ""
    };
  },

  computed: {
    ...mapGetters({
      sending: "newsletter/sending",
      response: "newsletter/response"
    })
  },

  methods: {
    close() {
      this.$store.dispatch("newsletter/toggleSubscribeNow", false);
    },

    async subscribe() {
      this.email = this.email.trim();
      if (!this.email || !this.email.length) return;

      this.$store.commit("newsletter/TOGGLE_SENDING", true);
      const isEmailVerified = await this.$options.filters.verifyEmail(
        this.email
      );
      if (!isEmailVerified) {
        await this.$store.dispatch("alert/setContent", {
          title: "Sorry",
          message: "Email not valid!",
          button: "Close",
          hasError: true
        });
        this.$store.commit("newsletter/TOGGLE_SENDING", false);
        this.$store.dispatch("alert/toggleAlert", true);
        return;
      }
      let formData = new FormData();
      formData.append("email", this.email);
      await this.$store.dispatch("newsletter/subscribe", formData);
      if (this.response.data && this.response.data.status === 200) {
        await this.$store.dispatch("alert/setContent", {
          title: "Success",
          message: "Successfully subscribed to newsletter.",
          button: "Awesome",
          hasError: false
        });
        this.email = "";
        this.$store.dispatch("alert/toggleAlert", true);
        return;
      }
      if (this.response.data.status == 422) {
        await this.$store.dispatch("alert/setContent", {
          title: "Sorry",
          message: this.response.data.errors.email[0],
          button: "Close",
          hasError: true
        });
        this.$store.dispatch("alert/toggleAlert", true);
        return;
      }
      await this.$store.dispatch("alert/setContent", {
        title: "Sorry",
        message: "Something went wrong!",
        button: "Close",
        hasError: true
      });
      this.$store.dispatch("alert/toggleAlert", true);
    }
  }
};
</script>

<style lang="scss" scoped>
.subscription {
  position: fixed;
  background-color: #333;
  height: 100vh;
  width: 100vw;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: $zIndex + 999;
  font-size: 16px;

  h2 {
    font-size: 2em;
  }

  p {
    font-size: 1.2em;
  }

  .close {
    color: #fff;
    cursor: pointer;
    display: inline-block;
    font-size: 2em;
    position: absolute;
    top: 0;
    left: 5px;
    user-select: none;
  }

  .subscription__bg,
  .subscription__content {
    height: 100%;
    width: 100%;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .subscription__bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-position: center;
  }

  .subscription__content {
    background-color: #00000025;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    padding: 10px;
  }

  .subscription__form {
    color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;

    > *:not(:last-child) {
      margin-bottom: 30px;
    }
  }

  .input-wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  input,
  button {
    padding: 15px 20px;
    border: none;
    outline: none;
    border-radius: 0;
    font-size: 0.8em;
  }

  button {
    min-width: 120px;
  }

  input {
    flex: 1 1 auto;
    margin-bottom: 10px;
  }

  .logo {
    width: 200px;
  }
}

@include desktop {
  .subscription {
    font-size: 18px;

    .subscription_form {
      max-width: 100%;
    }

    .close {
      font-size: 3em;
      top: 0;
      left: unset;
      right: 10px;
    }

    .input-wrapper {
      flex-direction: row;
    }

    input {
      margin-bottom: 0;
    }

    .logo {
      width: 400px;
    }
  }
}
</style>
